/* eslint-disable react-hooks/exhaustive-deps */
import Breadcrumcomponent from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import {
  ambienteAplicacion
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import useUsuario from "hooks/useUsuario";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";
import { Hogar } from "./constantes/general";
import pasosBreadCrumbHogar from "./constantes/pasosBreadCrumb";
import DatosPersonales from "./formas/datosPersonales";
import "./styles.scss";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { URLS_PHP_8 } from "constants/urls_v2";

const HogarDatosAsegurado = ({
  history,
  addWarningToast,
  params: { idCotizacion },
  dataUsuario,
}) => {
  const [loading, setLoading] = useState(false);

  const { cliCodigoCore } = dataUsuario;

  const { isAgente, isDTC } = useUsuario();

  const [catalogo, setCatalogo] = useState({});

  useNavbarContext(Hogar.codProducto);

  const methods = useForm({ mode: "onChange" });
  const { handleSubmit, reset } = methods;

  const solicitarCatalogos = async () => {
    const solicitudCatalogos = {
      ambiente: ambienteAplicacion,
      prodCodigo: Hogar.codProducto,
      prodCodigoCore: Hogar.prodCodigoCore,
      pasoCodigo: "informacionCliente",
      datosCotizador: {
        idCotizacion: idCotizacion ?? "",
        prodCodigo: Hogar.codProducto,
        cotPasoCodigo: { descripcion: "informacionContratanteInmueble" }, //informacionRequerida
        usuCotiza: {
          usuCodigo: cliCodigoCore || "",
        },
      },
    };
    const resp = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.catalogosCotizador, solicitudCatalogos);

    console.log("CATALOGO", resp);
    return resp;
  };

  const getData = async (catalogo) => {
    //Activar la pantalla de carga
    setLoading(true);

    //Cuerpo de la consulta de catalogos
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
    };

    console.log("Enviando:", DataResumen);

    //Obtener la informacion personal del cliente
    const resResumen = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.resumenCotizacion, DataResumen);

    const { codigoAgente = "" } = resResumen?.cotConsulta?.carAsesor;
    const agente = catalogo?.permisos?.agentes?.find?.(
      (agente) => agente.codigoAgente === codigoAgente
    );

    //Rellenar los datos en la forma
    reset({
      datosCliente: {
        ...resResumen?.cotConsulta?.carContratante,
      },
      agente,
    });

    //Desactivar la pantalla de carga
    setLoading(false);
  };

  useEffect(() => {
    //Se ejecuta solo si ya existe la cotizacion
    const solicitudes = async () => {
      setLoading(true);
      const respCatalogo = await solicitarCatalogos();
      setCatalogo(respCatalogo?.catalogo);
      if (idCotizacion) {
        await getData(respCatalogo?.catalogo);
      }
      setLoading(false);
    };

    solicitudes();
  }, [idCotizacion]);

  const onSubmit = async (data) => {
    setLoading(true);

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: Hogar.codProducto,
      prodCodigoCore: isAgente
        ? data.datosCliente.planSeleccionado
        : Hogar.prodCodigoCore,
      proTipoPlan: Hogar.proTipoPlan,
      pasoCodigo: "informacionCliente",
      items: {
        cotCodigo: idCotizacion || "",
        datosCliente: data.datosCliente,
        usuCotiza: { usuCodigo: cliCodigoCore || "" },
        agente: data.agente,
      },
    };

    const res = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.actualizarCotizacion, Data);

    console.log(res?.errorDescripcion);

    if (res?.transaccion === true && res?.id) {
      if (res?.warnings?.forEach) {
        res.warnings.forEach((warning) => {
          addWarningToast(warning, { autoDismiss: false });
        });
      }
      if (isAgente) {
        history.replace(`${Hogar.urls.datosPersonales}/${res?.id}`);
        history.push(`${Hogar.urls.individualFlexible1}/${res?.id}`);
      } else {
        history.replace(`${Hogar.urls.datosPersonales}/${res?.id}`);
        history.push(`${Hogar.urls.coberturas}/${res?.id}`);
      }
    } else {
      reset(data);
      try {
        res.errorDescripcion.forEach((msg) =>
          addWarningToast(msg, { autoDismiss: false })
        );
      } catch (e) {
        addWarningToast(res?.errorDescripcion || "Error desconocido", {
          autoDismiss: false,
        });
      }
    }
    setLoading(false);
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <Breadcrumcomponent {...pasosBreadCrumbHogar.breadCrumb} showPaths={false} />

          {isDTC ? (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumbPasosCotizacion[1]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosCotizacion}
            />
          ) : (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]
                .breadCrumbPasosCotizacionHogarFlex[1]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosHogarFlex}
            />
          )}

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <div className="row justify-content-center">
                <div className="col-12 col-lg-3"> */}
              <DatosPersonales
                //disclaimer={disclaimer}
                catalogo={catalogo}
                inputs={[
                  "usuNombre",
                  "usuTelefono",
                  "usuCorreo",
                  "usuRFC",
                  "usuCodPostal",
                  "usuEstado",
                  "usuMunicipio",
                  "usuColonia",
                  "usuTipoContratante",
                  "disclaimerTerminos",
                ]}
                clavesAgente={catalogo?.permisos?.agentes}
                opcionesPlan={catalogo?.tipoPlan?.map((plan) => plan.contenedor)}
              />
              {/* </div>
              </div> */}
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(HogarDatosAsegurado);
